export default function dynamicBaseHref() {
  const pathArr = `${window.location.origin + window.location.pathname}`.split('/');
  const href = pathArr.slice(0, -1).join('/') + '/';

  const baseEl = document.createElement('base');
  baseEl.setAttribute('href', href);
  document.head.appendChild(baseEl);
}
